import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgGoogleCalendarRegularIcon = (props) => /* @__PURE__ */ _jsxs("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	viewBox: "0 0 48 48",
	...props,
	children: [
		/* @__PURE__ */ _jsx("path", {
			fill: "#fff",
			d: "M13 13h22v22H13z"
		}),
		/* @__PURE__ */ _jsx("path", {
			fill: "#1e88e5",
			d: "m25.7 21 1 1.4 1.6-1.2v8.4H30v-11h-1.4zm-2.8 2.7a3 3 0 0 0 1-2.2c0-1.8-1.5-3.2-3.4-3.2-1.6 0-3 1-3.3 2.5l1.7.4q.3-1 1.6-1.1 1.6.1 1.7 1.4c.1 1.3-.7 1.4-1.7 1.4h-1v1.8h1q1.8.1 2 1.6-.1 1.6-1.9 1.6-1.6-.1-2-1.4l-1.6.3a4 4 0 0 0 3.6 2.9c2 0 3.6-1.5 3.6-3.4q0-1.6-1.3-2.6"
		}),
		/* @__PURE__ */ _jsx("path", {
			fill: "#fbc02d",
			d: "M34 42H14l-1-4 1-4h20l1 4z"
		}),
		/* @__PURE__ */ _jsx("path", {
			fill: "#4caf50",
			d: "m38 35 4-1V14l-4-1-4 1v20z"
		}),
		/* @__PURE__ */ _jsx("path", {
			fill: "#1e88e5",
			d: "m34 14 1-4-1-4H9a3 3 0 0 0-3 3v25l4 1 4-1V14z"
		}),
		/* @__PURE__ */ _jsx("path", {
			fill: "#e53935",
			d: "M34 34v8l8-8z"
		}),
		/* @__PURE__ */ _jsx("path", {
			fill: "#1565c0",
			d: "M39 6h-5v8h8V9a3 3 0 0 0-3-3M9 42h5v-8H6v5a3 3 0 0 0 3 3"
		})
	]
});
export default SvgGoogleCalendarRegularIcon;
